import { WebappRoutes } from "@/shared/lib/webapp-routes"
import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { rootRoute } from "../__root"

export const webappRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: WebappRoutes.ADVISORS,
  component: lazyRouteComponent(() => import("./lazy-pages"), "WebappShell"),
})
